<div class="px-8">
  <p-card class="m-2">
    <form [formGroup]="form" (ngSubmit)="onSubmit()" class="space-y-6">
      <div class="flex justify-between items-center border-b pb-4">
        <h2 class="text-xl font-bold text-gray-800">
          {{ isEditMode ? 'Editar Mesa' : 'Nova Mesa' }}
        </h2>
      </div>
      <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <label class="block mb-1 text-sm font-medium text-gray-700">Número da mesa *</label>
          <p-inputNumber
            formControlName="number"
            inputId="restaurant-table-number"
            [min]="1"
            class="w-full"
            placeholder="Ex: 1"
            [ngClass]="{
              'ng-invalid ng-dirty':
                form.get('number')?.invalid && form.get('number')?.touched
            }"
          ></p-inputNumber>
          <small
            class="text-red-500"
            *ngIf="form.get('number')?.invalid && form.get('number')?.touched"
          >
            Número é obrigatório (mínimo 1)
          </small>
        </div>
        <div *ngIf="isEditMode">
          <label class="block mb-1 text-sm font-medium text-gray-700">Ativo</label>
          <p-dropdown
            [options]="[
              { label: 'Sim', value: true },
              { label: 'Não', value: false }
            ]"
            formControlName="active"
            placeholder="Ativo"
            class="w-full"
          ></p-dropdown>
        </div>
      </div>
      <div class="pt-4 text-right">
        <button
          pButton
          type="button"
          label="Cancelar"
          icon="pi pi-times"
          class="p-button-secondary mr-2"
          (click)="goBack()"
        ></button>
        <button
          pButton
          type="submit"
          label="Salvar"
          icon="pi pi-save"
          class="p-button-primary"
        ></button>
      </div>
    </form>
  </p-card>
</div>
